var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.71 39.981a5.954 5.954 0 00-1.228-1.896 5.717 5.717 0 00-1.82-1.279l-.018-.008a3.98 3.98 0 001.566-3.19c0-2.174-1.691-3.935-3.779-3.935-2.087 0-3.778 1.761-3.778 3.935 0 1.313.617 2.476 1.566 3.192l-.018.008c-.682.3-1.295.73-1.82 1.279a5.98 5.98 0 00-1.228 1.896 6.109 6.109 0 00-.45 2.192.13.13 0 00.035.091.12.12 0 00.087.039h.914c.067 0 .12-.056.122-.124a4.828 4.828 0 011.338-3.242 4.45 4.45 0 013.232-1.395 4.45 4.45 0 013.233 1.395 4.829 4.829 0 011.338 3.242c.001.07.055.124.122.124h.914a.12.12 0 00.087-.039.13.13 0 00.035-.091 6.124 6.124 0 00-.45-2.194zm-5.279-3.643c-.699 0-1.357-.284-1.852-.8a2.77 2.77 0 01-.768-1.93c0-.728.273-1.413.768-1.93a2.552 2.552 0 011.852-.8c.7 0 1.358.285 1.853.8a2.77 2.77 0 01.768 1.93 2.77 2.77 0 01-.768 1.93c-.495.516-1.153.8-1.852.8z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.613 29.082a2.956 2.956 0 11-5.913 0 2.956 2.956 0 015.913 0zM34.55 22.582a2.956 2.956 0 11-5.913 0 2.956 2.956 0 015.913 0z",
    stroke: "#fff",
    strokeWidth: 1.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.344,
    cy: 29.082,
    r: 2.956,
    stroke: "#fff",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/Customers.a257798226f7fb8ea1a2675ff01ac46d.svg";
export { ForwardRef as ReactComponent };